import { PlantsReference } from '../../core/api/api.entities';
import { FormOptions } from './base.form-options';

export class SelectPlantsFormOptions extends FormOptions {
  plants: PlantsReference[] = [];
}
